import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import remHtml from '../../util/removeHtml';

const useStyles = makeStyles(theme => ({
  linkedContentContainer: {
    cursor: 'pointer',
    marginBottom: 10,
    height: 200,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.main,
  },
  linkedContentTitle: {
    color: 'white',
    fontSize: 30,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  linkedContentType: {

  },
  typetypography: {
    color: 'white',
    fontStyle: 'italic',
  },
}));

export default function LinkedContentView(props) {
  const classes = useStyles();
  const { linkedContent, onClickEnabled, history } = props;
  if (!linkedContent) return null;

  const { linkedContentId, linkedContentName, linkedContentType } = linkedContent;

  const handleOnClick = () => {
    if (!onClickEnabled) return null;
    switch (linkedContentType) {
      case 'Card':
        history.push(`/courses/-1?cardId=${linkedContentId}`);
        break;
      case 'Course':
        history.push(`/courses/${linkedContentId}`);
        break;
      case 'Question':
        history.push(`/tests/-1?questionId=${linkedContentId}`);
        break;
      case 'Test':
        history.push(`/tests/${linkedContentId}`);
        break;
      default: return '';
    }

    return null;
  };

  const getType = () => {
    switch (linkedContentType) {
      case 'Card': return 'Kärtchen';
      case 'Course': return 'Kurs';
      case 'Question': return 'Frage';
      case 'Test': return 'Test';
      default: return '';
    }
  };

  return (
    <div className={classes.linkedContentContainer} onClick={handleOnClick}>
      <div className={classes.linkedContentType}>
        <Typography className={classes.typetypography}>{getType()}</Typography>
      </div>
      <Typography className={classes.linkedContentTitle}>{remHtml(linkedContentName)}</Typography>

    </div>

  );
}

LinkedContentView.propTypes = {
  linkedContent: PropTypes.object.isRequired,
  onClickEnabled: PropTypes.bool,
  history: PropTypes.object.isRequired,
};

LinkedContentView.defaultProps = {
  onClickEnabled: true,
};



// WEBPACK FOOTER //
// ./src/app/main/socialwall/linked-content-view.js